// TODO - we should make stories to see everything on one page
// import React from 'react';
// import { storiesOf } from '@storybook/react';
// import { action } from '@storybook/addon-actions';
// import IconSettings from '../../../icon-settings';
//
// // import { POPOVER } from '../../../utilities/constants';
// // import Header from '../__examples__/header';
// // import AlternativeHeader from '../__examples__/alternative-header';
// // import ControlledWithFooter from '../__examples__/controlled-with-footer';
//
// import Popover from '../../../popover';
// import Tooltip from '../../../tooltip';
// import Button from '../../../button';
//
//
// let stories = storiesOf('Dialog', module)
// 	.addDecorator((getStory) => (
// 		<div
// 			className="slds-p-around_medium slds-m-horizontal_x-large"
// 			style={{
// 				margin: '300px auto',
// 				textAlign: 'center',
// 				width: '500px',
// 			}}
// 		>
// 			<IconSettings iconPath="/assets/icons">{getStory()}</IconSettings>
// 		</div>
// 	));
//
// stories = stories.add('Header', () => <Header />);
